const admissionStatus = {
  Unset: -1,
  Default: 0,
  NoVinculado: 1,
  ServicioRelacionadoActivo: 4,
  NoVigenteAlta: 5,
  NoVigenteBajas: 6,
  Alertas: 9,
  Admitido: 11,
  Vinculado: 12,
  Asignado: 13,
  NoVigenteFinDeAnoEscolar: 14,
  NoVigenteTraslado: 18,
  ReferidoRechazado: 22,
  ReferidoDirectorCSEE: 23,
  AprobadoRemedioProvisional: 24,
  NoVigenteCambioServicio: 25,
  NoVigenteEgreso: 30,
};

export default admissionStatus;
